import { SelectionModel } from '@angular/cdk/collections';
import { Component,  EventEmitter,  Input,  OnDestroy,  OnInit,  OnChanges,  SimpleChanges,  Output} from '@angular/core';
import { DatePipe } from '@angular/common';
import { ControlContainer, FormGroupDirective, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormControl } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, Observable, of } from 'rxjs';
import { concatMap, takeUntil, map } from 'rxjs/operators';
import { UsedSzza012aService } from '../../../../../sg-kd-shared/services/used-szza012a.service';
import { SgKdConstants } from '../../../../../sg-kd-shared/sg-kd-constants';
import { Sgkd020dSrnInfo } from '../../models/sgkd020d-srn-info';
import { Sgkd020dKohuriAceptDirect } from '../../models/sgkd020d-kohuri-acept-direct';
import { Sgkd020dKohuriAceptPost } from '../../models/sgkd020d-kohuri-acept-post';
import { Sgkd020dKohuriAceptCredit } from '../../models/sgkd020d-kohuri-acept-credit';

import { Sgkd020dSearchResult } from '../../models/sgkd020d-search-result';
import { UsedSgkd020dSgkd034aService } from '../../services/used-sgkd020d-sgkd034a.service';
import { UsedSgkd020dSgkd044aService } from '../../services/used-sgkd020d-sgkd044a.service';
import { UsedSgkd020dSgkd045aService } from '../../services/used-sgkd020d-sgkd045a.service';
import { UsedSgkd020dSgkd049aService } from '../../services/used-sgkd020d-sgkd049a.service';
import { UsedSgkd020dSgkz011aService } from '../../services/used-sgkd020d-sgkz011a.service';
import { UsedSgkd020dKouzaTypeService } from '../../services/used-sgkd020d-kouza-type.service';
import { UsedSgkd020dKouzaFubiInfoService } from '../../services/used-sgkd020d-kouza-fubi-info.service';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';
import { SelectBox, TimeApiService, UsedSgkz011aService } from 'cbc-shared-lib';

import {
  Sgkd034aResponse,
  Sgkd044aResponse,
  Sgkd045aResponse,
  Sgkd034aResponseAddrInfo,
  Sgkd034aResponseClmtoAddrInfo,
  Sgkd049aResponse,
  Sgkd049aSrnAceptInfoReponseDto,
  Sgkz011aResponse,
  CodeConversionMstDto,
} from 'sg-api';
import { FubiSelectBox } from '../../models/sgkd020d-fubi-select';
import { Sgkd020dRegistInfo } from '../../models/sgdk020d-regist_info';
import { List } from 'lodash';
import { Sgkd020dPrintInfo } from '../../models/skgd020d-print_info';
//import { SelectBox } from '../../../../../../../../../cbc-shared-lib/src/lib/shared/models/selectBox.model';
//import { CodeConversionMstDto } from '../../../../../../../../../sg-api/src/app/shared-api';

const TabName = {
  // 依頼書不備
  irai: '0',
  // 銀行不備
  bank: '1',
  // ＳＧ業務不備
  sg: '2',
} as const;
type TabName = typeof TabName[keyof typeof TabName];

@Component({
  selector: 'app-sgkd020d-search-condition',
  templateUrl: './sgkd020d-search.component.html',
  styleUrls: ['./sgkd020d-search.component.scss']
})
export class Sgkd020dSearchComponent implements OnInit, OnDestroy {

  private onDestroy$ = new Subject();

  /** メインフォーム */
  mainForm = this.parent.form;
  /** 検索フォーム */
  searchForm: UntypedFormGroup;
  
  /** 選択タブ */
  selectedTab: number;

  /** URLパラメータ 支払方法コード */
  @Input() urlParamPayMethod: string;

  /** レスポンスエミッター(口座振替) */
  @Output() responseDirectEmitter = new EventEmitter<Sgkd020dKohuriAceptDirect>();
  /** レスポンスエミッター(ゆうちょ) */
  @Output() responsePostEmitter = new EventEmitter<Sgkd020dKohuriAceptPost>();
  /** レスポンスエミッター(クレジット) */
  @Output() responseCreditEmitter = new EventEmitter<Sgkd020dKohuriAceptCredit>();
  /** メッセージクリア通知イベント */
  @Output() selectEvent = new EventEmitter<string>();
  /** 登録ボタン押下通知イベント */
  @Output() registEvent = new EventEmitter<Sgkd020dRegistInfo>();
  /** 取消ボタン押下通知イベント */
  @Output() deleteEvent = new EventEmitter<Sgkd020dRegistInfo>();
  /** 不備のお知らせ出力ボタン押下通知イベント */
  @Output() printEvent = new EventEmitter<Sgkd020dPrintInfo>();
  
  /** メッセージクリア通知イベント */
  @Output() clearMessageEvent = new EventEmitter<string>();

  selectedKouzaType: string | null = null;

  /** html側で参照 */
  readonly PAYMETHOD = SgKdConstants.CODE.PAYMETHOD.USER_CODE;

  /** 業務日付 */
  businessDate: string;

  /** 検索結果 */
  result: Sgkd020dSearchResult = {};

  /** 口座振替フラグ */
  kouzaFlg: boolean = false;

  /** クレジットフラグ */
  crdFlg: boolean = false;

  /** 検索実行フラグ */
  searchFlg: boolean = false;

  /** 請求お客さま番号 */
  recptFixNo: string = ""; 

  /** 支払方法コード */
  payMthdiv: string = "";

  /** 登録キー情報 */
//  registInfo: Sgkd020dRegistInfo = {}; 
  
  /** 口振 依頼書不備*/
  reqdocFubiDataSource: MatTableDataSource<FubiSelectBox> = new MatTableDataSource<FubiSelectBox>();
  /** 選択行情報 */
  reqdocFubiSelection: SelectionModel<FubiSelectBox> = new SelectionModel<FubiSelectBox>(true, []);
  /** 口振 銀行不備 */
  bankFubiDataSource: MatTableDataSource<FubiSelectBox> = new MatTableDataSource<FubiSelectBox>();
  /** 選択行情報 */
  bankFubiSelection: SelectionModel<FubiSelectBox> = new SelectionModel<FubiSelectBox>(true, []);
  /** 口振 SG業務不備 */
  sgFubiDataSource: MatTableDataSource<FubiSelectBox> = new MatTableDataSource<FubiSelectBox>();
  /** 選択行情報 */
  sgFubiSelection: SelectionModel<FubiSelectBox> = new SelectionModel<FubiSelectBox>(true, []);
  /** クレジット 記入漏れ */
  missInfoFubiDataSource: MatTableDataSource<FubiSelectBox> = new MatTableDataSource<FubiSelectBox>();
  /** 選択行情報 */
  missInfoSelection: SelectionModel<FubiSelectBox> = new SelectionModel<FubiSelectBox>(true, []);
  /** クレジット カード情報 */
  cardFubiDataSource: MatTableDataSource<FubiSelectBox> = new MatTableDataSource<FubiSelectBox>();
  /** 選択行情報 */
  cardFubiSelection: SelectionModel<FubiSelectBox> = new SelectionModel<FubiSelectBox>(true, []);
  /** クレジット 登録内容 */
  registrationFubiDataSource: MatTableDataSource<FubiSelectBox> = new MatTableDataSource<FubiSelectBox>();
  /** 選択行情報 */
  registrationFubiSelection: SelectionModel<FubiSelectBox> = new SelectionModel<FubiSelectBox>(true, []);

  // 選択タブ
  currentSelection!: SelectionModel<any>;

  /** コード変換マスタレスポンス */
  codeConversionMstMap: Map<string, Array<CodeConversionMstDto>> = null;

  /** タイトル */
  kouzaTitle: string = '';

  /** 口座振替切替ラジオボタン表示・非表示 */
  showKouzaTransfer: boolean = false;

  /** 申込書種別リスト */
  moshikomiKindList: CodeConversionMstDto[] = []; 

  /** 口振不備理由コードリスト */
  koufuriList: CodeConversionMstDto[] = []; 

  /** 口振不備理由コードマップ */
  koufuriMap = new Map<string, string>();

  /** クレジット不備理由コードリスト */
  crdList: CodeConversionMstDto[] = []; 
  
  /** 口振不備理由コードマップ */
  crdMap = new Map<string, string>();

  /** 申込書種別 */
  moshikomiKind: string = ""; 

  /** 契約種別 */
  ocUCtrClsfy: string;

  //type TabName = typeof TabName[keyof typeof TabName];
  
  /** テーブル表示カラム*/
  displayedColumnsCol: string[] = [
    'select',
    'value',
    'viewValue'
  ];

  /** 口座振替受付情報(口座) - テーブル表示列  */
  displayedDirectColumns: string[] = [
    // 選択行
    'select',
    // 登録日
    'registrationDate',
    // 更新日
    'updateDate',
    // 受付状態名称
    'aceptStateAname',
    // 不備理由(TODO)
    'hubiReason',
    // 金融機関名
    'bankfcMei',
    // 支店名
    'brncnm',
    // 預金者名義
    'bankAccountName',
    // 預金種目
    'dptClsfy',
    // 口座番号
    'kouzaNo'
  ];

  /** 口座振替受付情報(クレジット) - テーブル表示列  */
  displayedCreditColumns: string[] = [
    // 選択行
    'select',
    // 登録日
    'registrationDate',
    // 更新日
    'updateDate',
    // 受付状態名称
    'aceptStateAname',
    // 不備理由
    'hubiReason',
    // クレジットカード名義(カナ) 
    'crdKananame',
    // クレジット企業コード
    'cregitCoCode',
    // クレジット企業名
    'cregitCoName',
    // DBキー 
    'dbKey'
  ];

  /** 口座振替受付情報 */
  dataDirectSource: MatTableDataSource<Sgkd020dKohuriAceptDirect>;
  /** 口座振替受付情報(クレジット) */
  dataCreditSource: MatTableDataSource<Sgkd020dKohuriAceptCredit>;

  /** 検索 */
  noResult: boolean = false;

  /** 受付情報タイトル */
  aceptTitle: string = '';

  /** 登録済フラグ */
  registFlg: boolean = false;

  // 不備理由チェックボックス活性制御 */
  fubiDisabled: boolean = true; 

  readonly sgkd020dSrnInfo$ = this.kouzaFubiInfoService.sgkd020dSrnInfo$;

  disabledNewButton: boolean = false;
  reqdocFubiCodeList: any;
  loadedCodeList: boolean;
  companyCodeList: SelectBox[] = [];
  bankFubiCodeList: SelectBox[];
  sgFubiCodeList: SelectBox[];
  reqdocFubiKindList: SelectBox[];
  cardFubiKindList: SelectBox[];
  cardFubiCodeList: SelectBox[];

  kohuricreMskmaceptMno: string;
  aceptState: string;
  isNew: boolean = false;
  selectDirectVal: string | null = null;
  selectCreditVal: string | null = null;

  /**
   * コンストラクタ
   * @memberof Sgkd020dSearchComponent
   */
  constructor(
    private parent: FormGroupDirective,
    private formBuilder: UntypedFormBuilder,
    private usedSzza012aService: UsedSzza012aService,
    private usedSgkd020dSgkd034aService: UsedSgkd020dSgkd034aService,
    private usedSgkd020dSgkd044aService: UsedSgkd020dSgkd044aService,
    private usedSgkd020dSgkd045aService: UsedSgkd020dSgkd045aService,
    private usedSgkd020dSgkd049aService: UsedSgkd020dSgkd049aService,
    private usedSgkd020dSgkz011aService: UsedSgkd020dSgkz011aService,
    private kouzaTypeService: UsedSgkd020dKouzaTypeService,
    private kouzaFubiInfoService: UsedSgkd020dKouzaFubiInfoService,
    private codeConversionMstService: CodeConversionMstService,
    private datePipe: DatePipe) {
  }

  /**
   * 初期処理
   * 
   * @memberof Sgkd020dSearchComponent
   */
  ngOnInit(): void {
    this.initialize();
  }

  /**
   * Input変更時処理
   */
  ngOnChanges(changes: SimpleChanges): void {

    if (changes['urlParamPayMethod']) {
      this.initialize();
    }
  }

  /**
   * 初期値設定
   * 
   * @memberof Sgkd020dSearchComponent
   */
  private initialize(): void {

    // エラーメッセージクリア
    this.clearMessageEvent.emit();

    this.mainForm = this.parent.form;
    this.mainForm.removeControl('searchForm');

    this.searchForm = this.createForm();
    this.mainForm.addControl('searchForm', this.searchForm);

    //this.searchForm.get('ctrVisitNo')?.setValue(SgKdConstants.STR.EMPTY);

    // 口座振替情報
    this.dataDirectSource = new MatTableDataSource<Sgkd020dKohuriAceptDirect>();
    // 口座振替情報(クレジット)
    this.dataCreditSource = new MatTableDataSource<Sgkd020dKohuriAceptCredit>()

    // タイトル設定
    this.kouzaTitle = this.urlParamPayMethod === SgKdConstants.SGKD020D.PAYMETHOD.KOUZA ? '口座' : 'クレジット';

      // 業務日付取得
    this.usedSzza012aService.doSzza012a()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        this.businessDate = response.todayDay;
      }, error => {
      });

    this.kouzaTypeService.selectedKouzaType$.subscribe(type => {
      this.selectedKouzaType = type;
    });

    // TAB初期位置を1つ目に設定
    this.selectedTab = 0;

    this.payMthdiv =  this.urlParamPayMethod;

    // コード値読込
    this.loadCodeList();

    // 口座振替とクレジットの判定
    if (this.urlParamPayMethod === SgKdConstants.SGKD020D.PAYMETHOD.KOUZA) {
      this.kouzaFlg = true;
      this.crdFlg = false;
    } else {
      this.kouzaFlg = false;
      this.crdFlg = true;
    }

    this.searchFlg = false;
    this.registFlg = false;
    this.clear();

    this.clearDirectInfo();
    this.clearCreditInfo();
    this.clearMoushikomiInfo();

    this.aceptState = "";
    this.kohuricreMskmaceptMno = null;
  }
  
  /**
   * 破棄処理
   * 
   * @memberof Sgkd020dSearchComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    if (this.mainForm) {
      this.mainForm.clearValidators();
      this.mainForm.updateValueAndValidity();
      this.mainForm.removeControl('searchForm');
    }
  }

  /**
   * 検索ボタン押下処理
   * 
   * @memberof Sgkd020dSearchComponent 
   */
  onClickSearch(): void {

    // エラーメッセージクリア
    this.clearMessageEvent.emit();

    // 入力値：契約番号取得
    const ctrVisitNo: string = this.searchForm.get('ctrVisitNo')?.value;

    this.clear();

    this.dataDirectSource.data = [];
    this.dataCreditSource.data = [];

    this.kohuricreMskmaceptMno = null;

    this.searchForm.get('ctrVisitNo')?.setValue(ctrVisitNo);

    // SGKD034A_住所情報・お客さま氏名取得API(契約お客さま番号)
    this.searchByFirstSrvctrNo(ctrVisitNo).pipe(
      concatMap(visitInfoRes => {
        // SGKD045A_支払情報返却API
        return this.searchSgkd045a(ctrVisitNo).pipe(
          map(sgkd045aRes => ({ visitInfoRes, sgkd045aRes }))
        );
      }),
      concatMap(({ visitInfoRes, sgkd045aRes }) => {
        // SGKD034A_住所情報・お客さま氏名取得API(請求お客さま番号)
        return this.searchByRecptFixNo(this.findRecptFixNo(sgkd045aRes)).pipe(
          map(clmtoAddrInfoRes => ({ visitInfoRes, sgkd045aRes, clmtoAddrInfoRes }))
        );
      }),
      concatMap(({ visitInfoRes, sgkd045aRes, clmtoAddrInfoRes }) => {
        // SGKD044A_クレジット企業コード取得API
        const crdCoCode = this.findCrdCoCode(sgkd045aRes);
        const sgkd44a$ = (SgKdConstants.SGKD020D.PAYMETHOD.CRD === this.urlParamPayMethod && crdCoCode)
                    ? this.searchSgkd44a(crdCoCode) : of(null);
        return sgkd44a$.pipe(
          map(crdCoRes => ({ visitInfoRes, sgkd045aRes, clmtoAddrInfoRes, crdCoRes }))
        );
      }),
      concatMap(({ visitInfoRes, sgkd045aRes, clmtoAddrInfoRes, crdCoRes }) => {
        // SGKD049A_口振・クレ申込受付取得API
        return this.searchSgkd049a(ctrVisitNo, this.findRecptFixNo(sgkd045aRes)).pipe(
          map(sgkd049aRes => ({ visitInfoRes, sgkd045aRes, clmtoAddrInfoRes, crdCoRes, sgkd049aRes }))
        );
      }),
      concatMap(({ visitInfoRes, sgkd045aRes, clmtoAddrInfoRes, crdCoRes, sgkd049aRes }) => {
        const userId = '';
        // SGKZ011A_ユーザ情報取得API
        return this.searchSgkz011a(userId).pipe(
          map(sgkz011aRes => ({ visitInfoRes, sgkd045aRes, clmtoAddrInfoRes, crdCoRes, sgkd049aRes, sgkz011aRes }))
        );
      }),
    ).subscribe(({ visitInfoRes, sgkd045aRes, clmtoAddrInfoRes, crdCoRes, sgkd049aRes, sgkz011aRes }) => {

      this.searchFlg = true;

      // 請求お客さま番号
      this.recptFixNo = sgkd045aRes.responseDto.payMethodInfo.recptFixNo;
      // 契約種別
      if (sgkd049aRes.responseDto.kohuricreMskmaceptInformationlist[0].ctrClsfy === "電力"){
        this.ocUCtrClsfy = "電気";
      } else if (sgkd049aRes.responseDto.kohuricreMskmaceptInformationlist[0].ctrClsfy === "ガス") {
        this.ocUCtrClsfy = "都市ガス";
      } else {
        // this.ocUCtrClsfy = sgkd049aRes.responseDto.kohuricreMskmaceptInformationlist[0].ctrClsfy;
        this.ocUCtrClsfy = "";
      }
      // 契約者住所情報
      const ctrperAddrInfo = visitInfoRes.responseDto.ctrperAddrInfo;
      // 請求先住所情報
      const clmtoAddrInfo = clmtoAddrInfoRes.responseDto.clmtoAddrInfo;
      // 不備理由情報
      const kohuricreMskmaceptInformationlist = sgkd049aRes.responseDto.kohuricreMskmaceptInformationlist;
//      const kohuricreMskmaceptInformationlist = [];
      // 子コンポーネントで取得した不備理由情報を使用したいので(全体の件数等の確認を行う為)、共有サービスに取得したデータを保持
      this.kouzaFubiInfoService.setSgkd020dSrnInfo({ kohuricreMskmaceptInformationlist });
      // 基本情報の設定
      this.setBaseInfo(this.recptFixNo, this.ocUCtrClsfy, ctrperAddrInfo, clmtoAddrInfo);
      // 口座振替情報の設定
      this.setKouzaHurikaeAcept(kohuricreMskmaceptInformationlist);

      if (!this.hasFubiData(kohuricreMskmaceptInformationlist)) {

        // 新規の場合の支払方法タイプを特定(口座振替、ゆうちょ、クレジット)
        // 口座振替の場合は、口座振替切替ラジオボタンの初期選択は口座振替
        if (this.kouzaFlg) {
          this.kouzaTypeService.setSelectedKouzaType(SgKdConstants.CODE.PAYMETHOD.USER_CODE.KOUZA);
          this.noResult = true;
          this.setEnableKofuri();
        } else {
          this.kouzaTypeService.setSelectedKouzaType(SgKdConstants.CODE.PAYMETHOD.USER_CODE.CRD);
          this.noResult = false; 
          this.searchForm.get('cregitCoCode')?.enable();
          this.searchForm.get('dbKey')?.enable();
          this.setEnableCredit();
        }

        this.setDirectInfo({} as Sgkd020dKohuriAceptDirect);
        this.setCreditInfo({} as Sgkd020dKohuriAceptCredit);

      } else {

        this.setSelectedKouzaTypeForUpdate(kohuricreMskmaceptInformationlist);
        this.noResult = false; 
      }

      // タブ選択の更新を呼び出すことで、チェックボックスによる活性制御を呼び出す
      this.onTabChange(this.selectedTab)

      // 口座情報を非活性にする
      this.setDisableKofuri();

      // クレジット情報を非活性にする
      this.setDisableCredit();

        //不備理由チェックボックスを非活性にする
      this.fubiDisabled = true;

      // 口座振替の場合、非活性に戻す
      if (this.kouzaFlg){
        // 「ご契約者名」の活性制御 
        this.changeCtrerMeiControl();
  
        // 「住所」の活性制御 
        this.changeAddressControl();
      }  
      
    });

    this.selectDirectVal = null;
    this.selectCreditVal = null;
    this.isNew = false;
  }

  /**
   * クリアボタン押下処理* 
   * @memberof Sgkd020dSearchComponent 
   */
  onClickClear(): void {
    this.initialize();
  }

  /**
   * 新規ボタン押下処理* 
   * @public
   * @memberof Sgkd020dSearchComponent 
   */
  onClickNew(): void {

    this.clearMessageEvent.emit();

    this.clearDirectInfo();
    this.clearCreditInfo();
    this.clearMoushikomiInfo();

    this.aceptState = "";
    this.kohuricreMskmaceptMno = null;

    if (!this.isNew) {
      if (this.kouzaFlg) {
        let newDirect = { select: SgKdConstants.STR.EMPTY };
        let data = this.dataDirectSource.data;
        data.push(newDirect);
        this.selectDirectVal = SgKdConstants.STR.EMPTY;
        this.dataDirectSource.data = data;
      } else {
        let newCredit = { select: SgKdConstants.STR.EMPTY };
        let data = this.dataCreditSource.data;
        data.push(newCredit);
        this.selectCreditVal = SgKdConstants.STR.EMPTY;
        this.dataCreditSource.data = data;
      }
    }
    
    this.isNew = true;
    this.registFlg = false;

    //不備理由チェックボックスを活性にする
    this.fubiDisabled = false;

    // クレジットの場合、常時活性のため以下を呼び出す
    if (!this.kouzaFlg){
      // 「ご契約者名」の活性制御 
      this.changeCtrerMeiControl();

      // 「住所」の活性制御 
      this.changeAddressControl();
    }    

  }

  /**
   * 口座情報クリア処理* 
   * @memberof Sgkd020dSearchComponent 
   */
  clearDirectInfo(): void {
    this.searchForm.get('mozmigKanji')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('mozmigKana')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('bankfcCode')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('bankfcMei')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('branchCode')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('branchMei')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('dptcls')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('accntn')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('visitKyhNo')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('crdKananame')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('cregitCoCode')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('cregitCoName')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('dbKey')?.setValue(SgKdConstants.STR.EMPTY);

    this.bankFubiSelection.clear(false);
    this.reqdocFubiSelection.clear(false);
    this.sgFubiSelection.clear(false);

    this.setEnableKofuri();

    this.selectDirectVal = null;
  }

  /**
   * クレジット情報クリア処理* 
   * @memberof Sgkd020dSearchComponent 
   */
  clearCreditInfo(): void {
    this.searchForm.get('dptprsMeigiDiff')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('etcHubirsn')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('ctrerMei')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('postno')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('prefectureaname')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('administrativecitywardname')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('choname')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('chome')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('buildingnumber')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('visitSupadrAname')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('visitYagouAname')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('remarks')?.setValue(SgKdConstants.STR.EMPTY);

    this.missInfoSelection.clear(false);
    this.cardFubiSelection.clear(false);
    this.registrationFubiSelection.clear(false);

    this.setEnableCredit();

    this.selectCreditVal = null;
  }

  /**
   * 申込情報クリア処理* 
   * @memberof Sgkd020dSearchComponent 
   */
  clearMoushikomiInfo(): void {
    this.searchForm.get('regDate')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('creator')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('sshUpdator')?.setValue(SgKdConstants.STR.EMPTY);
    this.searchForm.get('sshksnDate')?.setValue(SgKdConstants.STR.EMPTY);
  }

  /**
   * 登録ボタン押下処理
   * 
   * @memberof Sgkd020dSearchComponent
   */
  onClickRegist(): void {

      let registInfo = {
        kohuricreMskmaceptMno: this.kohuricreMskmaceptMno,
        koshinFlg: true,
        firstSrvctrNo: this.searchForm.get('ctrVisitNo')?.value,
        recptFixNo: this.recptFixNo,
        payMthdiv: this.payMthdiv,
        aceptState: this.aceptState
      }
      this.registEvent.emit(registInfo);

  }

  /**
   * 登録ボタン活性制御
   * 
   * @returns 非活性の場合true/活性の場合false
   * @memberof Sgkd020dSearchComponent 
   */
  disabledBtnRegist(): boolean {
    if (this.isNew || !this.isNullOrEmpty(this.kohuricreMskmaceptMno)) {
      // 新規登録、受付選択が空の場合
      if (this.kouzaFlg) {
        // 口座振替申込受付
        if (this.reqdocFubiSelection.isEmpty() && this.bankFubiSelection.isEmpty() && this.sgFubiSelection.isEmpty()) {
          // チェックボックス未選択の場合、非活性
          return true;
        }
      } else {
        // クレジット申込受付
        if (this.missInfoSelection.isEmpty() && this.cardFubiSelection.isEmpty() && this.registrationFubiSelection.isEmpty()) {
          // チェックボックス未選択の場合、非活性
          return true;
        }
      }
      return false;
    } else {
      // 初期表示の場合
      return true;
    }
  }

  /**
   * 不備のおしらせ出力ボタン活性制御
   * 
   * @returns 非活性の場合true/活性の場合false
   * @memberof Sgkd020dSearchComponent 
   */
  disabledBtnPrint(): boolean {
    if (this.isNew || !this.isNullOrEmpty(this.kohuricreMskmaceptMno)) {
      // 新規登録、受付選択が空の場合
      if (this.kouzaFlg) {
        // 口座振替申込受付
        if (this.reqdocFubiSelection.isEmpty() && this.bankFubiSelection.isEmpty() && this.sgFubiSelection.isEmpty()) {
          // チェックボックス未選択の場合、非活性
          return true;
        } else {
            // チェックボックス選択済
            if (!this.registFlg){
              // 登録ボタンを押下していなければ非活性
              return true; 
            }
        }
      } else {
        // クレジット申込受付
        if (this.missInfoSelection.isEmpty() && this.cardFubiSelection.isEmpty() && this.registrationFubiSelection.isEmpty()) {
          // チェックボックス未選択の場合、非活性
          return true;
        } else {
            // チェックボックス選択済
            if (!this.registFlg){
              // 登録ボタンを押下していなければ非活性
              return true; 
          }
        }
      }
      return false;
    } else {
      // 初期表示の場合
      return true;
    }
  }

  private isNullOrEmpty(value: string): boolean {
    return value === null || value === undefined || value === SgKdConstants.STR.EMPTY;
  }

  /**
   * 取消ボタン押下処理
   * 
   * @memberof Sgkd020dSearchComponent
   */
  onClickDelete(): void {
    
    const result = window.confirm('選択した受付情報が取消されますがよろしいですか？');
    if (result) {
      let registInfo  = {
        kohuricreMskmaceptMno: this.kohuricreMskmaceptMno,
        koshinFlg: false,
        firstSrvctrNo: this.searchForm.get('ctrVisitNo')?.value,
        recptFixNo: this.recptFixNo
      }
      this.deleteEvent.emit(registInfo);
    } else {
      return;
    } 
  }

  /**
   * 印刷ボタン押下処理
   * 
   * @memberof Sgkd020dSearchComponent
   */
  onClickPrint(): void {

    if (this.kouzaFlg) {
      // 口座振替申込受付

      if (!this.reqdocFubiSelection.isEmpty()){
        // 依頼書不備が選択されている場合印刷する
        this.emitPrint(0);
      }  
      if (!this.bankFubiSelection.isEmpty()){
        // 銀行不備が選択されている場合印刷する
        this.emitPrint(1);
      }  
      if (!this.sgFubiSelection.isEmpty()){
        // ＳＧ業務不備が選択されている場合印刷する
        this.emitPrint(2);
      }  

    } else {
      // クレジット申込受付

      if (!this.missInfoSelection.isEmpty()){
        // 依頼書不備が選択されている場合印刷する
        this.emitPrint(0);
      }  
      if (!this.cardFubiSelection.isEmpty()){
        // カード情報不備が選択されている場合印刷する
        this.emitPrint(1);
      }  
      if (!this.registrationFubiSelection.isEmpty()){
        // ＳＧ業務不備が選択されている場合印刷する
        this.emitPrint(2);
      }  

    }

  }

  /**
   * 印刷イベント呼び出し
   */
  private emitPrint(tabIdx: number){

    let printInfo  = {
      srndocClsCode: this.changeMoshikomiKind(this.urlParamPayMethod),
      firstSrvctrNo: this.searchForm.get('ctrVisitNo')?.value,
      idx:tabIdx,
      payMthdiv: this.payMthdiv
    }
    this.printEvent.emit(printInfo);

  }

  
  /**
   * 支払方法変換
   */
  private setSelectedKouzaTypeForUpdate(
    kohuricreMskmaceptInformationlist: Array<Sgkd049aSrnAceptInfoReponseDto>
  ): void {

    const payMethodDiv =
      kohuricreMskmaceptInformationlist[0]?.payMthdiv;

    this.kouzaTypeService.setSelectedKouzaType(
      payMethodDiv
    );

  }

  /**
   * 口座振替切替ラジオボタン（口座振替選択）
   */
  onSelectDirect(): void {

    this.kouzaTypeService.setSelectedKouzaType(SgKdConstants.CODE.PAYMETHOD.USER_CODE.KOUZA);
    this.payMthdiv = SgKdConstants.CODE.PAYMETHOD.USER_CODE.KOUZA;
    this.selectedTab = 0
  }

  /**
   * 口座振替切替ラジオボタン（ゆうちょ選択）
   */
  onSelectPost(): void {
    this.kouzaTypeService.setSelectedKouzaType(SgKdConstants.CODE.PAYMETHOD.USER_CODE.KOUZA_Y);
    this.payMthdiv = SgKdConstants.CODE.PAYMETHOD.USER_CODE.KOUZA_Y;
    this.selectedTab = 0
  }
  
  /**
   * 不備理由情報有無判定
   * 
   * @param kohuricreMskmaceptInformationlist 
   * @returns 
   */
  private hasFubiData(kohuricreMskmaceptInformationlist: Array<Sgkd049aSrnAceptInfoReponseDto>): boolean {
    return kohuricreMskmaceptInformationlist && kohuricreMskmaceptInformationlist.length !== 0
  }

  /**
   * コード値読込
   *
   * @memberof Sgkd020dFubiReasonComponent
   */
  private loadCodeList(): void {

    this.codeConversionMstService.getCodeConversionMst([
      SgKdConstants.CODE.REQDOC_FUBI_KIND_CODE.DISP_ITEM_ID,// 口振不備理由種別コード
      SgKdConstants.CODE.CARD_FUBI_KIND_CODE.DISP_ITEM_ID,// クレ不備理由種別コード
      SgKdConstants.CODE.REQDOC_FUBI_CODE.DISP_ITEM_ID,// 口振不備理由コード
      SgKdConstants.CODE.CARD_FUBI_CODE.DISP_ITEM_ID,// クレ不備理由コード
      SgKdConstants.CODE.MOSHIKOMI_CODE.DISP_ITEM_ID,// 申込書種別コード
    ])
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(data => {
        this.reqdocFubiDataSource.data = this.sortedCodeSelectBox(data.get(SgKdConstants.CODE.REQDOC_FUBI_CODE.DISP_ITEM_ID),"A1","01","09","99");
        this.bankFubiDataSource.data = this.sortedCodeSelectBox(data.get(SgKdConstants.CODE.REQDOC_FUBI_CODE.DISP_ITEM_ID),"A2","10","22","99");
        this.sgFubiDataSource.data = this.sortedCodeSelectBox(data.get(SgKdConstants.CODE.REQDOC_FUBI_CODE.DISP_ITEM_ID),"A3","23","99","");
        this.missInfoFubiDataSource.data = this.sortedCodeSelectBox(data.get(SgKdConstants.CODE.CARD_FUBI_CODE.DISP_ITEM_ID),"B1","01","05","");
        this.cardFubiDataSource.data = this.sortedCodeSelectBox(data.get(SgKdConstants.CODE.CARD_FUBI_CODE.DISP_ITEM_ID),"B2","06","10","");
        this.registrationFubiDataSource.data = this.sortedCodeSelectBox(data.get(SgKdConstants.CODE.CARD_FUBI_CODE.DISP_ITEM_ID),"B3","11","12","");
        this.moshikomiKindList = data.get(SgKdConstants.CODE.MOSHIKOMI_CODE.DISP_ITEM_ID)
        this.koufuriList =data.get(SgKdConstants.CODE.REQDOC_FUBI_CODE.DISP_ITEM_ID);
        this.crdList = data.get(SgKdConstants.CODE.CARD_FUBI_CODE.DISP_ITEM_ID);
        this.koufuriMap.clear();
        this.crdMap.clear();
        this.koufuriList.forEach(x => {
        this.koufuriMap.set(x.userCode, x.hyojiCont);
        });
        this.crdList.forEach(x => {
        this.crdMap.set(x.userCode, x.hyojiCont);});
        });
  }

  
  /**
   * コードリストを項目並び順番でソートしたセレクトボックスを取得
   * @param array - コードリスト
   * @returns - 項目並び順番でソートされたコードリストのセレクトボックス
   *
   * @memberof Sgkd020dFubiReasonComponent
   */
  private sortedCodeSelectBox(array: Array<CodeConversionMstDto>,kindCode: string,low: string,high: string,eq: string): FubiSelectBox[] {

    let returnArray: FubiSelectBox[] = [];
    array
      .sort((x, y) => x.hyojiRowTurn.localeCompare(y.hyojiRowTurn))
      .forEach(x => {
        if ((x.userCode >= low && x.userCode <= high) || x.userCode == eq){
          returnArray.push({ value: x.userCode, viewValue: x.hyojiCont, kind: kindCode});
        } 
      }
    )  

    return returnArray;
  }

  /**
   * クリアボタン活性制御
   * 
   * @returns 非活性の場合true/活性の場合false
   * @memberof Sgkd020dSearchComponent 
   */
  disabledCleaerButton(): boolean {
    if (this.searchForm.get('visitKyhNo')?.value !== SgKdConstants.STR.EMPTY) {
      return false;
    }
    return true;
  }

  /**
   * 口座振替受付情報ラジオボタン選択
   * @param select Sgkd020dKohuriAceptDirect
   */
  selectDirectOne(select: Sgkd020dKohuriAceptDirect) {
    if (this.isNullOrEmpty(select.kohuricreMskmaceptMno)) {
      return;
    }
    this.selectDirectVal = select.select ?? null;
    if (this.isNew) {
      let data = this.dataDirectSource.data;
      let index = data.length - 1;
      data.splice(index);
      this.dataDirectSource.data = data;
    }
    this.setDirectInfo(select);
    this.isNew = false;

    // 受付状態が不備ありの場合
    if (this.aceptState == SgKdConstants.CODE.ACEPT_STATE.USER_CODE.FUBI){
      // 口座情報を活性
      this.setEnableKofuri();
    } else {
      // 口座情報を非活性
      this.setDisableKofuri();
    }

    // 不備理由チェックボックスを活性にする
    this.fubiDisabled = false;

    // 「預金者名義の相違」の活性制御
    this.changeDptprsMeigiDiffControl();

    // 「その他不備理由」の活性制御
    this.changeEtcFubiControl();  
    
    // 「ご契約者名」の活性制御 
    this.changeCtrerMeiControl();
    
    // 「住所」の活性制御 
    this.changeAddressControl();
    
    // 登録済フラグをON
    this.registFlg = true;
  }

  /**
   * 口座振替情報設定
   * @param directInfo 
   */
  private setDirectInfo(directInfo: Sgkd020dKohuriAceptDirect) {
    this.setDirectResult(directInfo);
  }

  /**
   * クレジット受付情報ラジオボタン選択
   * @param select Sgkd020dKohuriAceptCredit
   */
  selectCreditOne(select: Sgkd020dKohuriAceptCredit) {
    if (this.isNullOrEmpty(select.kohuricreMskmaceptMno)) {
      return;
    }
    this.selectCreditVal = select.select ?? null;
    if (this.isNew) {
      let data = this.dataCreditSource.data;
      let index = data.length - 1;
      data.splice(index);
      this.dataCreditSource.data = data;

    }
    this.setCreditInfo(select);
    this.isNew = false;

    // 受付状態が不備ありの場合
    if (this.aceptState == SgKdConstants.CODE.ACEPT_STATE.USER_CODE.FUBI){
      // クレジット情報を活性
      this.setEnableCredit();
    } else {
      // クレジット情報を非活性
      this.setDisableCredit();
    }
      
    // 不備理由チェックボックスを活性にする
    this.fubiDisabled = false;

    // 「ご契約者名」の活性制御 
    this.changeCtrerMeiControl();
    
    // 「住所」の活性制御 
    this.changeAddressControl();

    // 登録済フラグをON
    this.registFlg = true;

  }

  /**
   * 口座振替情報(クレジット)設定
   * @param creditInfo 
   */
  private setCreditInfo(creditInfo: Sgkd020dKohuriAceptCredit) {
    this.setCreditResult(creditInfo);
  }

  /**
   * 基本情報の設定
   * @param claimCtrNo 支払契約番号
   * @param ocUCtrClsfy 契約種別
   * @param visitInfo お客さま情報
   * @param clmtoInfo 請求先情報
   * @memberof Sgkd020dSearchComponent 
   */
  private setBaseInfo(claimCtrNo: string, ocUCtrClsfy: string, visitInfo: Sgkd034aResponseAddrInfo, clmtoInfo: Sgkd034aResponseClmtoAddrInfo) {
    // 請求お客さま番号
    this.searchForm.get('claimCtrNo').setValue(claimCtrNo);
    // 契約種別
    this.searchForm.get('ocUCtrClsfy').setValue(ocUCtrClsfy);
    // お客さま情報
    this.searchForm.get('visitInfo').setValue(visitInfo ? this.createvisitInfo(visitInfo) : SgKdConstants.STR.EMPTY);
    // 請求先情報
    this.searchForm.get('clmtoInfo').setValue(clmtoInfo ? this.createvisitInfo(clmtoInfo) : SgKdConstants.STR.EMPTY);
    // 受付情報タイトル
    this.aceptTitle = ("1" === this.urlParamPayMethod ? "口座振替" : "クレジット") + "受付情報";

  }

  /**
   *  口座振替受付情報エリアの設定
   * @param kohuricreMskmaceptInformationlist 口振・クレ申込受付取得API実行後の情報
   */
  private setKouzaHurikaeAcept(kohuricreMskmaceptInformationlist: Array<Sgkd049aSrnAceptInfoReponseDto>) {

    // 口座振替受付情報(口座)
    this.setFilterKohuriAceptDirect(kohuricreMskmaceptInformationlist);
    // 口座振替受付情報(クレジット)
    this.filterKohuriAceptCredit(kohuricreMskmaceptInformationlist);

  }

  /**
   *  口座振替受付情報(口座)設定
   * @param kohuricreMskmaceptInformationlist 口振・クレ申込受付取得API実行後の情報
   */
  private setFilterKohuriAceptDirect(kohuricreMskmaceptInformationlist: Array<Sgkd049aSrnAceptInfoReponseDto>) {
   
    const hubiReason = [];

      const kohuriAceptDirectData = (kohuricreMskmaceptInformationlist ?? [])
      .filter(x => x.payMthdiv === SgKdConstants.CODE.PAYMETHOD.USER_CODE.KOUZA||x.payMthdiv === SgKdConstants.CODE.PAYMETHOD.USER_CODE.KOUZA_Y)
      .map(x => ({
        select: x.kohuricreMskmaceptMno,
        // 口振・クレ申込受付管理番号
        kohuricreMskmaceptMno: x.kohuricreMskmaceptMno,
        // 登録日
        registrationDate: this.formatDate(x.torokuTimestamp),
        // 更新日
        updateDate: this.formatDate(x.updateDate),
        // 受付状態(API側でコード変換)
        aceptStatus: x.aceptState,
        // 受付状態名称
        aceptStateAname: x.aceptStateAname,
        // 不備理由
        hubiReason: this.createFubiType(x),
        // お客さま記入番号
        visitKinyuno: x.visitKinyuno,
        // 口座名義カナ氏名
        mozmigKananame: x.mozmigKananame,
        // 金融機関コード
        bankfcCode:x.bankfcCode,
        // 支店コード
        brnccd:x.brnccd,
        // 金融機関名
        bankfcMei: x.bankfcMei,
        // 支店名
        brncnm: x.branchname,
        // 預金者名義
        bankAccountName: x.mozmigKnjnm,
        // 預金種目
        dptClsfy: x.dptClsfy,
        // 口座番号
        kouzaNo: x.kouzaNo,
        // 不備理由種別1 
        hubirsnClsfy1: x.hubirsnClsfy1,
        // 不備理由種別2 
        hubirsnClsfy2: x.hubirsnClsfy2,
        // 不備理由種別3
        hubirsnClsfy3: x.hubirsnClsfy3,
        // 不備理由種別4
        hubirsnClsfy4: x.hubirsnClsfy4,
        // 不備理由種別5
        hubirsnClsfy5: x.hubirsnClsfy5,
        // 不備理由種別6
        hubirsnClsfy6: x.hubirsnClsfy6,
        // 不備理由種別7
        hubirsnClsfy7: x.hubirsnClsfy7,
        // 不備理由種別8
        hubirsnClsfy8: x.hubirsnClsfy8,
        // 不備理由種別9
        hubirsnClsfy9: x.hubirsnClsfy9,
        // 不備理由種別10
        hubirsnClsfy10: x.hubirsnClsfy10,
        // 不備理由種別11
        hubirsnClsfy11: x.hubirsnClsfy11,
        // 不備理由種別12
        hubirsnClsfy12: x.hubirsnClsfy12,
        // 不備理由種別13
        hubirsnClsfy13: x.hubirsnClsfy13,
        // 不備理由種別14
        hubirsnClsfy14: x.hubirsnClsfy14,
        // 不備理由種別15
        hubirsnClsfy15: x.hubirsnClsfy15,
        // 不備理由種別16
        hubirsnClsfy16: x.hubirsnClsfy16,
        // 不備理由種別17
        hubirsnClsfy17: x.hubirsnClsfy17,
        // 不備理由種別18
        hubirsnClsfy18: x.hubirsnClsfy18,
        // 不備理由種別19
        hubirsnClsfy19: x.hubirsnClsfy19,
        // 不備理由種別20
        hubirsnClsfy20: x.hubirsnClsfy20,
        // 不備理由種別21
        hubirsnClsfy21: x.hubirsnClsfy21,
        // 不備理由種別22
        hubirsnClsfy22: x.hubirsnClsfy22,
        // 不備理由種別23
        hubirsnClsfy23: x.hubirsnClsfy23,
        // 不備理由種別24
        hubirsnClsfy24: x.hubirsnClsfy24,
        // 不備理由種別25
        hubirsnClsfy25: x.hubirsnClsfy25,
        // 不備理由種別26
        hubirsnClsfy26: x.hubirsnClsfy26,
        // 不備理由コード1 
        hubirsnCode1: x.hubirsnCode1,
        // 不備理由コード2
        hubirsnCode2: x.hubirsnCode2,
        // 不備理由コード3
        hubirsnCode3: x.hubirsnCode3,
        // 不備理由コード4
        hubirsnCode4: x.hubirsnCode4,
        // 不備理由コード5
        hubirsnCode5: x.hubirsnCode5,
        // 不備理由コード6
        hubirsnCode6: x.hubirsnCode6,
        // 不備理由コード7
        hubirsnCode7: x.hubirsnCode7,
        // 不備理由コード8
        hubirsnCode8: x.hubirsnCode8,
        // 不備理由コード9
        hubirsnCode9: x.hubirsnCode9,
        // 不備理由コード10
        hubirsnCode10: x.hubirsnCode10,
        // 不備理由コード11
        hubirsnCode11: x.hubirsnCode11,
        // 不備理由コード12
        hubirsnCode12: x.hubirsnCode12,
        // 不備理由コード13
        hubirsnCode13: x.hubirsnCode13,
        // 不備理由コード14
        hubirsnCode14: x.hubirsnCode14,
        // 不備理由コード15
        hubirsnCode15: x.hubirsnCode15,
        // 不備理由コード16
        hubirsnCode16: x.hubirsnCode16,
        // 不備理由コード17
        hubirsnCode17: x.hubirsnCode17,
        // 不備理由コード18
        hubirsnCode18: x.hubirsnCode18,
        // 不備理由コード19
        hubirsnCode19: x.hubirsnCode19,
        // 不備理由コード20
        hubirsnCode20: x.hubirsnCode20,
        // 不備理由コード21
        hubirsnCode21: x.hubirsnCode21,
        // 不備理由コード22
        hubirsnCode22: x.hubirsnCode22,
        // 不備理由コード23
        hubirsnCode23: x.hubirsnCode23,
        // 不備理由コード24
        hubirsnCode24: x.hubirsnCode24,
        // 不備理由コード25
        hubirsnCode25: x.hubirsnCode25,
        // 不備理由コード26
        hubirsnCode26: x.hubirsnCode26,
        // 預金者名義相違
        depositpersonMeigiDiff: x.depositpersonMeigiDiff,
        // その他不備理由
        etcHubirsn: x.etcHubirsn,  
        // ご契約者名
        ctrerMei: x.ctrerMei,
        // 郵便番号
        postno: x.postno,
        // 都道府県名
        prefectureaname: x.prefectureaname,
        // 行政市区名
        administrativecitywardname: x.administrativecitywardname,
        // 町名
        choname: x.choname,
        // 丁目
        chome: x.chome,
        // 番地・号
        buildingnumber: x.buildingnumber,
        // 住宅・棟号漢字名
        visitSupadrAname: x.visitSupadrAname,
        // 屋号・業種漢字名
        visitYagouAname: x.visitYagouAname,
        // 備考
        remarks: x.remarks,
        // 登録者社員番号
        creatorStaffNo: x.creatorStaffNo,
        // 登録者社員名
        creatorStaffname: x.creatorStaffname,
        // 最終更新者社員番号
        lastupdatepersonStafno: x.lastupdatepersonStafno,
        // 最終更新者社員名
        lastupdatepersonStaffname: x.lastupdatepersonStaffname
        
      }));

    this.dataDirectSource.data = [
      ...this.dataDirectSource.data,
      ...kohuriAceptDirectData
    ];
  }

  /**
   *  口座振替受付情報(クレジット)設定
   * @param kohuricreMskmaceptInformationlist 口振・クレ申込受付取得API実行後の情報
   */
  private filterKohuriAceptCredit(kohuricreMskmaceptInformationlist: Array<Sgkd049aSrnAceptInfoReponseDto>) {  

    let name: string ="" 

    const kohuriAceptCreditData = (kohuricreMskmaceptInformationlist ?? [])
      .filter(x => x.payMthdiv === SgKdConstants.CODE.PAYMETHOD.USER_CODE.CRD)
      .map(x => ({
        select: x.kohuricreMskmaceptMno,
        // 口振・クレ申込受付管理番号
        kohuricreMskmaceptMno: x.kohuricreMskmaceptMno,
        // 登録日
        registrationDate: this.formatDate(x.torokuTimestamp),
        // 更新日
        updateDate: this.formatDate(x.updateDate),
        // 受付状態(API側でコード変換)
        aceptStatus: x.aceptState,
        // 受付状態名称
        aceptStateAname: x.aceptStateAname,
        // 不備理由
        hubiReason: this.createFubiType(x),         
        // お客さま記入番号
        visitKinyuno: x.visitKinyuno,
        // クレジットカード名義(カナ)
        crdKananame: x.crdKananame,
        // クレジット企業コード
        cregitCoCode: x.crdCompanycode,
        // クレジット企業名
        cregitCoName: x.crdCompanyname,
        // DBキー
        dbKey: x.databaseKey,
        // 不備理由種別1 
        hubirsnClsfy1: x.hubirsnClsfy1,
        // 不備理由種別2 
        hubirsnClsfy2: x.hubirsnClsfy2,
        // 不備理由種別3
        hubirsnClsfy3: x.hubirsnClsfy3,
        // 不備理由種別4
        hubirsnClsfy4: x.hubirsnClsfy4,
        // 不備理由種別5
        hubirsnClsfy5: x.hubirsnClsfy5,
        // 不備理由種別6
        hubirsnClsfy6: x.hubirsnClsfy6,
        // 不備理由種別7
        hubirsnClsfy7: x.hubirsnClsfy7,
        // 不備理由種別8
        hubirsnClsfy8: x.hubirsnClsfy8,
        // 不備理由種別9
        hubirsnClsfy9: x.hubirsnClsfy9,
        // 不備理由種別10
        hubirsnClsfy10: x.hubirsnClsfy10,
        // 不備理由種別11
        hubirsnClsfy11: x.hubirsnClsfy11,
        // 不備理由種別12
        hubirsnClsfy12: x.hubirsnClsfy12,
        // 不備理由種別13
        hubirsnClsfy13: x.hubirsnClsfy13,
        // 不備理由種別14
        hubirsnClsfy14: x.hubirsnClsfy14,
        // 不備理由種別15
        hubirsnClsfy15: x.hubirsnClsfy15,
        // 不備理由種別16
        hubirsnClsfy16: x.hubirsnClsfy16,
        // 不備理由種別17
        hubirsnClsfy17: x.hubirsnClsfy17,
        // 不備理由種別18
        hubirsnClsfy18: x.hubirsnClsfy18,
        // 不備理由種別19
        hubirsnClsfy19: x.hubirsnClsfy19,
        // 不備理由種別20
        hubirsnClsfy20: x.hubirsnClsfy20,
        // 不備理由種別21
        hubirsnClsfy21: x.hubirsnClsfy21,
        // 不備理由種別22
        hubirsnClsfy22: x.hubirsnClsfy22,
        // 不備理由種別23
        hubirsnClsfy23: x.hubirsnClsfy23,
        // 不備理由種別24
        hubirsnClsfy24: x.hubirsnClsfy24,
        // 不備理由種別25
        hubirsnClsfy25: x.hubirsnClsfy25,
        // 不備理由種別26
        hubirsnClsfy26: x.hubirsnClsfy26,
        // 不備理由コード1 
        hubirsnCode1: x.hubirsnCode1,
        // 不備理由コード2
        hubirsnCode2: x.hubirsnCode2,
        // 不備理由コード3
        hubirsnCode3: x.hubirsnCode3,
        // 不備理由コード4
        hubirsnCode4: x.hubirsnCode4,
        // 不備理由コード5
        hubirsnCode5: x.hubirsnCode5,
        // 不備理由コード6
        hubirsnCode6: x.hubirsnCode6,
        // 不備理由コード7
        hubirsnCode7: x.hubirsnCode7,
        // 不備理由コード8
        hubirsnCode8: x.hubirsnCode8,
        // 不備理由コード9
        hubirsnCode9: x.hubirsnCode9,
        // 不備理由コード10
        hubirsnCode10: x.hubirsnCode10,
        // 不備理由コード11
        hubirsnCode11: x.hubirsnCode11,
        // 不備理由コード12
        hubirsnCode12: x.hubirsnCode12,
        // 不備理由コード13
        hubirsnCode13: x.hubirsnCode13,
        // 不備理由コード14
        hubirsnCode14: x.hubirsnCode14,
        // 不備理由コード15
        hubirsnCode15: x.hubirsnCode15,
        // 不備理由コード16
        hubirsnCode16: x.hubirsnCode16,
        // 不備理由コード17
        hubirsnCode17: x.hubirsnCode17,
        // 不備理由コード18
        hubirsnCode18: x.hubirsnCode18,
        // 不備理由コード19
        hubirsnCode19: x.hubirsnCode19,
        // 不備理由コード20
        hubirsnCode20: x.hubirsnCode20,
        // 不備理由コード21
        hubirsnCode21: x.hubirsnCode21,
        // 不備理由コード22
        hubirsnCode22: x.hubirsnCode22,
        // 不備理由コード23
        hubirsnCode23: x.hubirsnCode23,
        // 不備理由コード24
        hubirsnCode24: x.hubirsnCode24,
        // 不備理由コード25
        hubirsnCode25: x.hubirsnCode25,
        // 不備理由コード26
        hubirsnCode26: x.hubirsnCode26,
        // 預金者名義相違
        depositpersonMeigiDiff: x.depositpersonMeigiDiff,
        // その他不備理由
        etcHubirsn: x.etcHubirsn,  
        // ご契約者名
        ctrerMei: x.ctrerMei,
        // 郵便番号
        postno: x.postno,
        // 都道府県名
        prefectureaname: x.prefectureaname,
        // 行政市区名
        administrativecitywardname: x.administrativecitywardname,
        // 町名
        choname: x.choname,
        // 丁目
        chome: x.chome,
        // 番地・号
        buildingnumber: x.buildingnumber,
        // 住宅・棟号漢字名
        visitSupadrAname: x.visitSupadrAname,
        // 屋号・業種漢字名
        visitYagouAname: x.visitYagouAname,
        // 備考
        remarks: x.remarks,
        // 登録者社員番号
        creatorStaffNo: x.creatorStaffNo,
        // 登録者社員名
        creatorStaffname: x.creatorStaffname,
        // 最終更新者社員番号
        lastupdatepersonStafno: x.lastupdatepersonStafno,
        // 最終更新者社員名
        lastupdatepersonStaffname: x.lastupdatepersonStaffname
    }));

    this.dataCreditSource.data = [
      ...this.dataCreditSource.data,
      ...kohuriAceptCreditData
    ];
  }

  /**
   *  不備理由種別作成
   * @param kohuricreMskmaceptInformationlist 
   */
  private createFubiType(data: any): string {

    const clsfyList: string[] = [];
    
    for (let i = 1; i <= 26; i++) {
      const clsfy = data[`hubirsnClsfy${i}`];
    
      if (clsfy) {
        clsfyList.push(clsfy);
      }
    }

    // 口座
    if (clsfyList.includes('A3')) {
      return 'ＳＧ業務不備';
    }

    if (clsfyList.includes('A2')) {
      return '銀行不備';
    }
    
    if (clsfyList.includes('A1')) {
      return '依頼書不備';
    }
    
    // クレジット
    if (clsfyList.includes('B3')) {
      return 'ＳＧ業務不備';
    }
    
    if (clsfyList.includes('B2')) {
      return 'カード情報不備';
    }
    
    if (clsfyList.includes('B1')) {
      return '依頼書不備';
    }
    
    return '';
    
  }

    /**
   * 検索結果設定(口座振替)
   * 
   * @param directInfo 
   */
    setDirectResult(directInfo: Sgkd020dKohuriAceptDirect) {
    
      this.clearAllCheckbox()
      this.mainForm.patchValue({
        dptprsMeigiDiff: '',
        etcHubirsn: ''
      });    
    
      this.setResult(directInfo);
      
      this.searchForm.get('visitKyhNo').setValue(directInfo.visitKinyuno); 
      this.searchForm.get('mozmigKanji').setValue(directInfo.bankAccountName);  
      this.searchForm.get('mozmigKana').setValue(directInfo.mozmigKananame);
      this.searchForm.get('bankfcCode').setValue(directInfo.bankfcCode);
      this.searchForm.get('bankfcMei').setValue(directInfo.bankfcMei);
      this.searchForm.get('branchCode').setValue(directInfo.brnccd);
      this.searchForm.get('branchMei').setValue(directInfo.brncnm);
      this.searchForm.get('dptcls').setValue(directInfo.dptClsfy);
      this.searchForm.get('accntn').setValue(directInfo.kouzaNo);
  
      // 登録用の情報
      this.kohuricreMskmaceptMno = directInfo.kohuricreMskmaceptMno;
      this.aceptState = directInfo.aceptStatus;

      this.reqdocFubiSelection.clear();
      this.bankFubiSelection.clear();
      this.sgFubiSelection.clear();

      for (let i = 1; i <= 26; i++) {

        const clsfy = directInfo[`hubirsnClsfy${i}`];
        const code  = directInfo[`hubirsnCode${i}`];
      
        if (!clsfy || !code) {
          continue;
        }
      
        if (clsfy === 'A1') {
          const row = this.reqdocFubiDataSource.data.find(
            x => x.kind === clsfy && x.value === code
          );
          if (row) {
            this.reqdocFubiSelection.select(row);
          }
        }
      
        if (clsfy === 'A2') {
          const row = this.bankFubiDataSource.data.find(
            x => x.kind === clsfy && x.value === code
          );
          if (row) {
            this.bankFubiSelection.select(row);
          }
        }
      
        if (clsfy === 'A3') {
          const row = this.sgFubiDataSource.data.find(
            x => x.kind === clsfy && x.value === code
          );
          if (row) {
            this.sgFubiSelection.select(row);
          }
        }
      }

      this.searchForm.get('dptprsMeigiDiff').setValue(directInfo.depositpersonMeigiDiff); 
      this.searchForm.get('etcHubirsn').setValue(directInfo.etcHubirsn); 
      this.searchForm.get('ctrerMei').setValue(directInfo.ctrerMei); 
      this.searchForm.get('prefectureaname').setValue(directInfo.prefectureaname); 
      this.searchForm.get('postno').setValue(this.editPostno(directInfo.postno)); 
      this.searchForm.get('administrativecitywardname').setValue(directInfo.administrativecitywardname); 
      this.searchForm.get('choname').setValue(directInfo.choname); 
      this.searchForm.get('chome').setValue(directInfo.chome); 
      this.searchForm.get('buildingnumber').setValue(directInfo.buildingnumber); 
      this.searchForm.get('visitSupadrAname').setValue(directInfo.visitSupadrAname); 
      this.searchForm.get('visitYagouAname').setValue(directInfo.visitYagouAname); 
      this.searchForm.get('remarks').setValue(directInfo.remarks); 
      this.searchForm.get('regDate').setValue(this.formatDate(directInfo.registrationDate));
      this.searchForm.get('creator').setValue(directInfo.creatorStaffname);
      this.searchForm.get('sshksnDate').setValue(this.formatDate(directInfo.updateDate));
      this.searchForm.get('sshUpdator').setValue(directInfo.lastupdatepersonStaffname);

      // TAB初期選択
      this.selectedTab = 0;

      // タブ選択の更新を呼び出すことで、チェックボックスによる活性制御を呼び出す
      this.onTabChange(this.selectedTab)

      // 活性制御
      this.controlDisabledDirectCreditInfo();
    }

  /**
   * 口座情報非活性
   */
  setDisableKofuri() {
    this.searchForm.get('visitKyhNo')?.disable();
    this.searchForm.get('mozmigKanji')?.disable();
    this.searchForm.get('mozmigKana')?.disable();
    this.searchForm.get('bankfcCode')?.disable();
    this.searchForm.get('bankfcMei')?.disable();
    this.searchForm.get('branchCode')?.disable();
    this.searchForm.get('branchMei')?.disable();
    this.searchForm.get('dptcls')?.disable();
    this.searchForm.get('accntn')?.disable();
  }

  /**
   * 口座情報活性
   */
  setEnableKofuri() {
    this.searchForm.get('visitKyhNo')?.enable();
    this.searchForm.get('mozmigKanji')?.enable();
    this.searchForm.get('mozmigKana')?.enable();
    this.searchForm.get('bankfcCode')?.enable();
    this.searchForm.get('bankfcMei')?.enable();
    this.searchForm.get('branchCode')?.enable();
    this.searchForm.get('branchMei')?.enable();
    this.searchForm.get('dptcls')?.enable();
    this.searchForm.get('accntn')?.enable();
  }

  /**
   * 検索結果設定(クレジット)
   * 
   * @param creditInfo 
   */
  setCreditResult(creditInfo: Sgkd020dKohuriAceptCredit) {

    this.clearAllCheckbox()
    this.mainForm.patchValue({
      dptprsMeigiDiff: '',
      etcHubirsn: ''
    });    

    this.setResult(creditInfo);

    this.searchForm.get('visitKyhNo').setValue(creditInfo.visitKinyuno); 
    this.searchForm.get('crdKananame').setValue(creditInfo.crdKananame);  
    this.searchForm.get('cregitCoCode').setValue(creditInfo.cregitCoCode);
    this.searchForm.get('cregitCoName').setValue(creditInfo.cregitCoName);
    this.searchForm.get('dbKey').setValue(creditInfo.dbKey);

    // 登録用の情報
    this.kohuricreMskmaceptMno = creditInfo.kohuricreMskmaceptMno;
    this.aceptState = creditInfo.aceptStatus;

    for (let i = 1; i <= 26; i++) {

      const clsfy = creditInfo[`hubirsnClsfy${i}`];
      const code  = creditInfo[`hubirsnCode${i}`];
    
      if (!clsfy || !code) {
        continue;
      }
    
      if (clsfy === 'B1') {
        const row = this.missInfoFubiDataSource.data.find(
          x => x.kind === clsfy && x.value === code
        );
        if (row) {
          this.missInfoSelection.select(row);
        }
      }
    
      if (clsfy === 'B2') {
        const row = this.cardFubiDataSource.data.find(
          x => x.kind === clsfy && x.value === code
        );
        if (row) {
          this.cardFubiSelection.select(row);
        }
      }
    
      if (clsfy === 'B3') {
        const row = this.registrationFubiDataSource.data.find(
          x => x.kind === clsfy && x.value === code
        );
        if (row) {
          this.registrationFubiSelection.select(row);
        }
      }
    }

    this.searchForm.get('dptprsMeigiDiff').setValue(creditInfo.depositpersonMeigiDiff); 
    this.searchForm.get('etcHubirsn').setValue(creditInfo.etcHubirsn); 
    this.searchForm.get('ctrerMei').setValue(creditInfo.ctrerMei); 
    this.searchForm.get('prefectureaname').setValue(creditInfo.prefectureaname); 
    this.searchForm.get('postno').setValue(this.editPostno(creditInfo.postno)); 
    this.searchForm.get('administrativecitywardname').setValue(creditInfo.administrativecitywardname); 
    this.searchForm.get('choname').setValue(creditInfo.choname); 
    this.searchForm.get('chome').setValue(creditInfo.chome); 
    this.searchForm.get('buildingnumber').setValue(creditInfo.buildingnumber); 
    this.searchForm.get('visitSupadrAname').setValue(creditInfo.visitSupadrAname); 
    this.searchForm.get('visitYagouAname').setValue(creditInfo.visitYagouAname); 
    this.searchForm.get('remarks').setValue(creditInfo.remarks); 
    this.searchForm.get('regDate').setValue(this.formatDate(creditInfo.registrationDate));
    this.searchForm.get('creator').setValue(creditInfo.creatorStaffname);
    this.searchForm.get('sshksnDate').setValue(this.formatDate(creditInfo.updateDate));
    this.searchForm.get('sshUpdator').setValue(creditInfo.lastupdatepersonStaffname);

    this.selectedTab = 0;

    // タブ選択の更新を呼び出すことで、チェックボックスによる活性制御を呼び出す
    this.onTabChange(this.selectedTab)

    // 活性制御
    this.controlDisabledDirectCreditInfo();
  }

  controlDisabledDirectCreditInfo(): void {
    if (this.kouzaFlg) {
      if (this.aceptState == SgKdConstants.CODE.ACEPT_STATE.USER_CODE.DONE ||
        this.aceptState == SgKdConstants.CODE.ACEPT_STATE.USER_CODE.FUBI) {
        this.setDisableKofuri();
      } else {
        this.setEnableKofuri();
      }
    } else {
      if (this.aceptState == SgKdConstants.CODE.ACEPT_STATE.USER_CODE.DONE ) {
        this.setDisableCredit();
      } else {
        this.setEnableCredit();
      }
    }
  }
  
  /**
 * クレジット情報非活性
 */
  setDisableCredit() {
    this.searchForm.get('visitKyhNo')?.disable();
    this.searchForm.get('crdKananame')?.disable();
    this.searchForm.get('cregitCoCode')?.disable();
    this.searchForm.get('cregitCoName')?.disable();
    this.searchForm.get('dbKey')?.disable();
  }

  /**
   * クレジット情報活性
   */
  setEnableCredit() {
    this.searchForm.get('visitKyhNo')?.enable();
    this.searchForm.get('crdKananame')?.enable();
    this.searchForm.get('cregitCoCode')?.enable();
    this.searchForm.get('cregitCoName')?.enable();
    this.searchForm.get('dbKey')?.enable();
  }
    
  /**
   * チェックボックス一斉解除
   */
  clearAllCheckbox(): void {
    this.reqdocFubiSelection.clear();
    this.bankFubiSelection.clear();
    this.sgFubiSelection.clear();
    this.missInfoSelection.clear();
    this.cardFubiSelection.clear();
    this.registrationFubiSelection.clear();
  }

  /**
   * 検索結果設定
   * 
   * @param info 検索結果
   */
  private setResult<T>(info: T): void {

    const srnInfo =
      this.kouzaFubiInfoService.getSgkd020dSrnInfo();
  }
  
    /**
   * TAB選択の更新
   */
    onTabChange(index: number): void {

      this.selectedTab = index;

      if (this.kouzaFlg) {
        this.currentSelection = [    
          this.reqdocFubiSelection, 
          this.bankFubiSelection,
          this.sgFubiSelection
        ][index];
      } else {
        this.currentSelection = [
          this.missInfoSelection,
          this.cardFubiSelection,
          this.registrationFubiSelection
        ][index];
      }

    }  

  /**
   * 依頼書不備（口座振替）選択時
   * 
   * @param info 検索結果
   */
  onReqdocFubiChange(row: any): void {

    // 一覧最新化
    this.reqdocFubiSelection.toggle(row);

    // 「その他不備理由」の活性制御
    this.changeEtcFubiControl();
    
  }
  
  /**
   * 銀行不備選択時
   * 
   * @param info 検索結果
   */
  onBankFubiChange(row: any): void {

    // 一覧最新化
    this.bankFubiSelection.toggle(row);

    // 「預金者名義の相違」の活性制御
    this.changeDptprsMeigiDiffControl();

    // 「その他不備理由」の活性制御
    this.changeEtcFubiControl();  
  
  }

  /**
   * SG不備（口座振替）選択時
   * 
   * @param info 検索結果
   */
  onSgFubiChange(row: any): void {

    // 一覧最新化
    this.sgFubiSelection.toggle(row);
    
    // 「ご契約者名」の活性制御 
    this.changeCtrerMeiControl();
    
    // 「住所」の活性制御 
    this.changeAddressControl();
  
  }

  /**
   * 依頼書不備（クレジット）選択時
   * 
   * @param info 検索結果
   */
  onMissInfoFubiChange(row: any): void {

    // 一覧最新化
    this.missInfoSelection.toggle(row);
  
  }

  /**
   * カード不備選択時
   * 
   * @param info 検索結果
   */
  onCardFubiChange(row: any): void {

    // 一覧最新化
    this.cardFubiSelection.toggle(row);
  
  }

  /**
   * ＳＧ不備（クレジット）選択時
   * 
   * @param info 検索結果
   */
  onRegistrationInfoFubiChange(row: any): void {

    // 一覧最新化
    this.registrationFubiSelection.toggle(row);

  }

  /**
   * 預金者名義の相違の活性制御
   */
  private changeDptprsMeigiDiffControl(): void {
    // 「預金者名義の相違」入力活性   「不備理由：預金者名義の相違」の場合は活性
    const isCheckeddptprsMeigiDiff = this.bankFubiSelection.selected.some(x => x.value === '22');
    if (isCheckeddptprsMeigiDiff) {
        this.searchForm.get('dptprsMeigiDiff')?.enable();
    } else {
      this.searchForm.get('dptprsMeigiDiff')?.disable();
      this.searchForm.get('dptprsMeigiDiff')?.setValue('');
    }
  }

  /**
   * その他不備理由の活性制御
   * 
   */
  private changeEtcFubiControl(): void {
    const isCheckedReqdocEtc = this.reqdocFubiSelection.selected.some(x => x?.value === '99');
    const isCheckedBankEtc = this.bankFubiSelection.selected.some(x => x?.value === '99');
    
    // その他不備理由の活性制御
    if (isCheckedReqdocEtc || isCheckedBankEtc) {
      this.searchForm.get('etcHubirsn')?.enable();
    } else {
      this.searchForm.get('etcHubirsn')?.disable();
      this.searchForm.get('etcHubirsn')?.setValue('');
    }
  }

  /**
   * ご契約者名の活性制御
   */
  private changeCtrerMeiControl(): void {
    const isCheckedCtrerMei = this.sgFubiSelection.selected.some(x => x.value === '23');
    if (isCheckedCtrerMei || this.kouzaFlg == false) {
        this.searchForm.get('ctrerMei')?.enable();
    } else {
        this.searchForm.get('ctrerMei')?.disable();
        this.searchForm.get('ctrerMei')?.setValue('');
    }
  }

  /**
   * 住所の活性制御 
   */
  private changeAddressControl(): void {

    // 「住所」入力活性  「不備理由：住所相違、目標相違、目標なし」,またはクレジットの場合は活性 
    const isCheckedAddress = this.sgFubiSelection.selected.some(x => ['24','25','26'].includes(x.value))
    if (isCheckedAddress || this.kouzaFlg == false) {
      this.setEnableAddress();
    } else {
      this.setDisableAddress();
    }
  }

  /**
   * 住所情報活性
   */
  setEnableAddress() {
    this.searchForm.get('postno')?.enable();
    this.searchForm.get('prefectureaname')?.enable();
    this.searchForm.get('administrativecitywardname')?.enable();
    this.searchForm.get('choname')?.enable();
    this.searchForm.get('chome')?.enable();
    this.searchForm.get('buildingnumber')?.enable();
    this.searchForm.get('visitSupadrAname')?.enable();
    this.searchForm.get('visitYagouAname')?.enable();
  }
  
  /**
   * 住所情報非活性
   */
  setDisableAddress() {
    this.searchForm.get('postno')?.disable();
    this.searchForm.get('prefectureaname')?.disable();
    this.searchForm.get('administrativecitywardname')?.disable();
    this.searchForm.get('choname')?.disable();
    this.searchForm.get('chome')?.disable();
    this.searchForm.get('buildingnumber')?.disable();
    this.searchForm.get('visitSupadrAname')?.disable();
    this.searchForm.get('visitYagouAname')?.disable();

    this.searchForm.get('postno')?.setValue('');
    this.searchForm.get('prefectureaname')?.setValue('');
    this.searchForm.get('administrativecitywardname')?.setValue('');
    this.searchForm.get('choname')?.setValue('');
    this.searchForm.get('chome')?.setValue('');
    this.searchForm.get('buildingnumber')?.setValue('');
    this.searchForm.get('visitSupadrAname')?.setValue('');
    this.searchForm.get('visitYagouAname')?.setValue('');
  }

  /**
   * 契約お客さま情報の編集
   * @param visitInfo 契約お客さま情報 
   * @returns 編集した契約お客さま情報
   */
  private createvisitInfo(visitInfo: Sgkd034aResponseAddrInfo): string {

    const address = [
      visitInfo.prefectureaname,
      visitInfo.administrativecitywardname,
      visitInfo.choname,
      visitInfo.chome,
      visitInfo.buildingnumber,
      visitInfo.visitSupadrAname,
      visitInfo.visitYagouAname
    ].join('');

    const addressText = [
      `${visitInfo.visitName}`,
      `〒${this.editPostno(visitInfo.postno)}`,
      `${address}`
    ].join('\n');

    return addressText;
  }

  /**
   * 郵便番号の編集
   * インタフェース上
   * @param postno 
   * @returns 
   */
  private editPostno(postno: string): string {
    return postno
      ?.trim()
      ?.replace(/^(\d{3})(\d{4})$/, '$1-$2');
  }

  /**
   * 郵便番号の編集
   * インタフェース上
   * @param postno 
   * @returns 
   */
  private changeMoshikomiKind(paymethod: string): string {

    let kind ="";

    this.moshikomiKindList
    .forEach(x => {
      if (x.userCode == "0" + paymethod){
        kind = x.userCode;
      }
    })

    return kind
    
  }   

  /**
   * 口振申込情報の編集
   * @param getInfo 口振情報
   * @returns 編集した住所情報
   */
  private getDirectInfo(getInfo: Sgkd020dKohuriAceptDirect): string{
    
    const address = [
      getInfo.postno,
      getInfo.prefectureaname,
      getInfo.administrativecitywardname,
      getInfo.choname,
      getInfo.chome,
      getInfo.buildingnumber,
      getInfo.visitSupadrAname,
      getInfo.visitYagouAname
    ].join('\n');
  
    const addressText = [
      `${getInfo.ctrerMei}`,
      `〒${this.editPostno(getInfo.postno)}`,
      `${address}`
    ].join('\n');
      
    return addressText
  }
    
  /**
   * クレジット申込情報の編集
   * @param getInfo クレジット情報
   * @returns 編集した住所情報
   */
  private getCreditiInfo(getInfo: Sgkd020dKohuriAceptCredit): string{
    
    const address = [
      getInfo.postno,
      getInfo.prefectureaname,
      getInfo.administrativecitywardname,
      getInfo.choname,
      getInfo.chome,
      getInfo.buildingnumber,
      getInfo.visitSupadrAname,
      getInfo.visitYagouAname
    ].join('\n');
  
    const addressText = [
      `${getInfo.ctrerMei}`,
      `〒${this.editPostno(getInfo.postno)}`,
      `${address}`
    ].join('\n');
      
    return addressText
  }

  /**
   * YYYYMMDD→YYYY/MM/DD
   * @param date 8桁の日付
   * @returns YYYY/MM/DD形式に変換した日付
   */
  private formatDate(date: string | null | undefined): string {
    if (!date) {
      return SgKdConstants.STR.EMPTY;
    }

    return date.replace(
      /^(\d{4})(\d{2})(\d{2})$/,
      '$1/$2/$3'
    );
  }

  /**
   * フォームの生成
   * 
   * @returns 本コンポーネントのForm情報
   * @memberof Sgkd020dSearchComponent
   */
  private createForm(): UntypedFormGroup {
    let form = this.formBuilder.group({
      /** 契約番号 */
      ctrVisitNo: new UntypedFormControl(
        { value: '', disabled: false },
        [
          Validators.minLength(SgKdConstants.SGKD020D.MAX_LENGTH.CTR_VISIT_NO),
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.CTR_VISIT_NO),
          Validators.pattern(SgKdConstants.PATTERN.HAN_NUM)
        ]),
      /** 支払契約番号 */
      claimCtrNo: new UntypedFormControl(
        { value: '', disabled: true }),
      /** 契約種別 */
      ocUCtrClsfy: new UntypedFormControl(
        { value: '', disabled: true }),
      /** 契約情報 */
      visitInfo: new UntypedFormControl(
        { value: '', disabled: true }),
      /** 請求先情報 */
      clmtoInfo: new UntypedFormControl(
        { value: '', disabled: true }),
      /** 受付状態 */
      aceptState: new UntypedFormControl(
        { value: '', disabled: true }),
      /** お客さま記入番号 */
      visitKyhNo: new UntypedFormControl(
      { value: SgKdConstants.STR.EMPTY, disabled: true },
      [
        // 最大15桁
        Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.CTR_VISIT_NO),
        // 半角数字
        Validators.pattern(SgKdConstants.PATTERN.HAN_NUM)
      ]),
      /** 口座名義（漢字） */
      mozmigKanji: new UntypedFormControl(
        { value: SgKdConstants.STR.EMPTY, disabled: true },
        [
          // 最大24桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.KOUHURI_ACT_KNJ)
        ]),
      /** 口座名義（カナ） */
      mozmigKana: new UntypedFormControl(
        { value: SgKdConstants.STR.EMPTY, disabled: true },
        [
          // 最大30桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.MEIGI_KANA)
        ]),
      /** 金融機関コード */
      bankfcCode: new UntypedFormControl(
        { value: SgKdConstants.STR.EMPTY, disabled: true },
        [
          // 最小4桁
          Validators.minLength(SgKdConstants.SGKD020D.MIN_LENGTH.BANKFC_CODE),
          // 最大4桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.BANKFC_CODE),
          // 半角数字
          Validators.pattern(SgKdConstants.PATTERN.HAN_NUM)
        ]),
      /** 金融機関名 */
      bankfcMei: new UntypedFormControl(
        { value: SgKdConstants.STR.EMPTY, disabled: true },
        [
          // 最大20桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.BANKFC_MEI),
        ]),
      /** 支店コード */
      branchCode: new UntypedFormControl(
        { value: SgKdConstants.STR.EMPTY, disabled: true },
        [
          // 最小3桁
          Validators.minLength(SgKdConstants.SGKD020D.MIN_LENGTH.BRANCH_CODE),
          // 最大3桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.BRANCH_CODE),
          // 半角数字
          Validators.pattern(SgKdConstants.PATTERN.HAN_NUM)
        ]),
      /** 支店名 */
      branchMei: new UntypedFormControl(
        { value: SgKdConstants.STR.EMPTY, disabled: true },
        [
          // 最大20桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.BRNCNM),
        ]),
      /** 預金種別 */
      dptcls: new UntypedFormControl(
        { value: SgKdConstants.STR.EMPTY, disabled: true },
        [
          // 最大6桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.DPT_CLSFY),
        ]),
      /** 口座番号 */
      accntn: new UntypedFormControl(
        { value: SgKdConstants.STR.EMPTY, disabled: true },
        [
          // 最大7桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.KOUZA_NO),
          // 半角数字
          Validators.pattern(SgKdConstants.PATTERN.HAN_NUM)
        ]),
      /** 通帳記号 */
      pbookKigo: new UntypedFormControl(
        { value: SgKdConstants.STR.EMPTY, disabled: false },
        [
          // 最大3桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.PBOOK_KIGO),
          // 半角数字
          Validators.pattern(SgKdConstants.PATTERN.HAN_NUM)
        ]),
      /** 通帳番号 */
      pbookNo: new UntypedFormControl(
        { value: SgKdConstants.STR.EMPTY, disabled: false },
        [
          // 最大8桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.PBOOK_NO),
          // 半角数字
          Validators.pattern(SgKdConstants.PATTERN.HAN_NUM)
        ]),
      /** クレジットカード名義(カナ) */
      crdKananame: new UntypedFormControl(
        { value: SgKdConstants.STR.EMPTY, disabled: true },
        [
          // 最大30桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.CRD_KANA_NAME),
          // 全角カナ
          Validators.pattern(SgKdConstants.PATTERN.ZEN_KANA)
        ]),
      /** クレジット企業コード */
      cregitCoCode: new UntypedFormControl(
        { value: SgKdConstants.STR.EMPTY, disabled: true },
        [
          // 最大5桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.CRD_CO_CODE),
          // 半角数字
          Validators.pattern(SgKdConstants.PATTERN.HAN_NUM)
        ]),
      /** クレジット企業名 */
      cregitCoName: new UntypedFormControl(
        { value: SgKdConstants.STR.EMPTY, disabled: true },
        [
          // 最大20桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.CRD_CO_NM),
        ]),
      /** DBキー */
      dbKey: new UntypedFormControl(
        { value: SgKdConstants.STR.EMPTY, disabled: true },
        [
          // 最大16桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.CRD_DB_KEY),
          // 半角数字
          Validators.pattern(SgKdConstants.PATTERN.HAN_NUM)
        ]),
      /** 預金者名義の相違 */
      dptprsMeigiDiff: new UntypedFormControl(
        { value: '', disabled: true }, [
          // 最大150桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.DPTPRS_MEIGI_DIFF)
        ]),
      /** その他不備理由 */
      etcHubirsn: new UntypedFormControl(
        { value: '', disabled: true },
        [
          // 最大150桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.ETC_HUBIRSN)
        ]
      ),
      /** ご契約者名 */
      ctrerMei: new UntypedFormControl(
        { value: '', disabled: true },
        [
          // 最大20桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.CTRER_MEI)
        ]
      ),
      /** 郵便番号 */
      postno: new UntypedFormControl(
        { value: '', disabled: true },
        [
          // 最大8桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.POST_NO)
        ]
      ),
      /** 都道府県名 */
      prefectureaname: new UntypedFormControl(
        { value: '', disabled: true },
        [
          // 最大12桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.PREFECTUREA_NAME)
        ]
      ),
      /** 行政市区名 */
      administrativecitywardname: new UntypedFormControl(
        { value: '', disabled: true },
        [
          // 最大12桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.ADMINISTR_ATIVECITY_WARD_NAME)
        ]
      ),
      /** 町名 */
      choname: new UntypedFormControl(
        { value: '', disabled: true },
        [
          // 最大18桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.CHONAME)
        ]
      ),
      /** 丁目 */
      chome: new UntypedFormControl(
        { value: '', disabled: true },
        [
          // 最大12桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.CHOME)
        ]
      ),
      /** 番地・号 */
      buildingnumber: new UntypedFormControl(
        { value: '', disabled: true },
        [
          // 最大10桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.BUILDING_NUMBER)
        ]
      ),
      /** 建物名 */
      visitSupadrAname: new UntypedFormControl(
        { value: '', disabled: true },
        [
          // 最大20桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.VISIT_SUPADRA_NAME)
        ]
      ),
      /** 目標・部屋番号 */
      visitYagouAname: new UntypedFormControl(
        { value: '', disabled: true },
        [
          // 最大20桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.VISIT_SUPADRA_NAME)
        ]
      ), 
      /** 備考欄 */
      remarks: new UntypedFormControl(
        { value: '', disabled: false },
        [
          // 最大150桁
          Validators.maxLength(SgKdConstants.SGKD020D.MAX_LENGTH.REMARKS)
        ]
      ), 
      /** 登録日 */
      regDate: new UntypedFormControl(
        { value: '', disabled: true }),
      /** 登録者 */
      creator: new UntypedFormControl(
        { value: '', disabled: true }),
      /** 最終更新日 */
      sshksnDate: new UntypedFormControl(
        { value: '', disabled: true }),
      /** 最終更新者 */
      sshUpdator: new UntypedFormControl(
        { value: '', disabled: true }),
    });         
    return form;
  }

  /**
   * クリア処理
   * 
   * @memberof Sgkd020dSearchComponent
   */
  private clear(): void {

    this.mainForm.reset();
    this.reqdocFubiSelection.clear();
    this.bankFubiSelection.clear();
    this.sgFubiSelection.clear();
    this.missInfoSelection.clear();
    this.cardFubiSelection.clear();
    this.registrationFubiSelection.clear();

    this.noResult = false;
  }    

  /**
   * yyyyMMddHHmm形式の文字列をDate型に変換する
   *
   * @param {string} date
   * @return {*}  {Date}
   * @memberof Sgkd020dSearchComponent
   */
  private convertStringToDate(date: string): Date | null {
    let result: Date | null = null;
    if (date && date != '') {
      const yyyy = Number(date.slice(0, 4));
      const MM = Number(date.slice(4, 6)) - 1;
      const dd = Number(date.slice(6, 8));
      const hour = Number(date.slice(8, 10));
      const minute = Number(date.slice(10, 12));
      result = new Date(yyyy, MM, dd, hour, minute);
    }
    return result;
  }

  /**
   * yyyyMMddHHmm形式の文字列をDate型に変換する
   *
   * @param {string} date
   * @return {*}  {Date}
   * @memberof Sgkd020dSearchComponent
   */
  private setCheckBox(){

  }

  /**
   * SGKD034A_住所情報・お客さま氏名取得API(契約お客さま番号)
   * 
   * @memberof Sgkd020dComponent
   */
  private searchByFirstSrvctrNo(firstSrvctrNo: string): Observable<Sgkd034aResponse> {
    return this.usedSgkd020dSgkd034aService.doSgkd034a(
      SgKdConstants.CODE_SHTKTARGETTBLDIV_KEIYAKUSAKI, firstSrvctrNo, null, this.businessDate);
  }

  /**
   * SGKD045A_支払情報返却API
   * 
   * @memberof Sgkd020dComponent
   */
  private searchSgkd045a(visitNo: string): Observable<Sgkd045aResponse> {
    return this.usedSgkd020dSgkd045aService.doSgkd045a(visitNo);
  }

  /**
   * SGKD034A_住所情報・お客さま氏名取得API(請求お客さま番号)
   * 
   * @memberof Sgkd020dComponent
   */
  private searchByRecptFixNo(recptFixNo: string): Observable<Sgkd034aResponse> {
    return this.usedSgkd020dSgkd034aService.doSgkd034a(
      SgKdConstants.CODE_SHTKTARGETTBLDIV_SEIKYUSAKI, null, recptFixNo, this.businessDate);
  }

  /**
   * SGKD044A_クレジット企業コード取得API
   * @param cleNo クレジット企業コード
   * @returns Sgkd044aResponse
   */
  private searchSgkd44a(cleNo: string): Observable<Sgkd044aResponse> {
    return this.usedSgkd020dSgkd044aService.doSgkd044a();
  }

  /**
   * SGKD049A_口振・クレ申込受付取得API
   * @param recptFixNo 支払契約番号
   * @param firstSrvctrNo 契約お客さま番号
   * @param recptFixNo 支払契約番号
   * @returns Sgkd049aResponse
   */
  private searchSgkd049a(
    firstSrvctrNo: string,
    recptFixNo: string): Observable<Sgkd049aResponse> {
    return this.usedSgkd020dSgkd049aService.doSgkd049a(this.urlParamPayMethod, firstSrvctrNo, recptFixNo);
  }

  /**
   * SGKZ011A_ユーザ情報取得API
   * @param userId ユーザID
   * @returns Sgkd110aResponse
   */
  private searchSgkz011a(
    userId: string): Observable<Sgkz011aResponse> {
    return this.usedSgkd020dSgkz011aService.doSgkz011a(userId);
  }

  /**
   * 支払情報返却APIレスポンスより請求お客さま番号抽出
   * 
   * @memberof Sgkd020dComponent
   */
  private findRecptFixNo(response: Sgkd045aResponse): string | undefined {
    return response.responseDto?.payMethodInfo?.recptFixNo;
  }

  /**
   * 支払情報返却APIレスポンスより請求お客さま番号抽出
   * 
   * @memberof Sgkd020dComponent
   */
  private findCrdCoCode(response: Sgkd045aResponse): string | undefined {
    return response.responseDto?.payMethodInfo?.crdInfo?.crdcoCode;
  }
}
